import React, { useState, useEffect } from 'react'
import Gantt, {
  Tasks,
  Column,
  Editing,
  Toolbar,
  Item,
  ContextMenu,
} from 'devextreme-react/gantt'
import { locale, loadMessages } from 'devextreme/localization'
import { Popup } from 'devextreme-react/popup'
import { Grid, FormControl, TextField, Button } from '@material-ui/core'
import { Stack } from '@mui/material'
import swal from 'sweetalert'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import Moment from 'moment'
import { getTechnicalAssistanceImplementationActivities } from '../../../../../../services/AsistenciaTecnica/get'

const Table26 = ({
  IdTechnicalAssistanceAnswer,
  StartExecutionPeriod,
  EndExecutionPeriod,
}) => {
  loadMessages({
    es: {
      Yes: 'Sí',
      'dxCollectionWidget-noDataText': 'No hay registros a desplegar',
      'dxDataGrid-noDataText': 'No hay registros a desplegar',
      'No data': 'No hay registros a desplegar',
      'dxListEditDecorator-delete': 'Eliminar',
      'dxDataGrid-editingDeleteRow': 'Eliminar',
      'dxDataGrid-editingConfirmDeleteMessage':
        '¿Está seguro que desea eliminar este registro?',
      'dxScheduler-confirmRecurrenceDeleteMessage':
        '¿Quiere eliminar solo esta cita o toda la serie?',
      'dxScheduler-confirmRecurrenceDeleteSeries': 'Eliminar serie',
      'Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?':
        'Eliminar',
      'dxDataGrid-editingUndeleteRow': 'ff',
      'dxGantt-dialogTaskDeleteConfirmation':
        '¿Está seguro que desea eliminar este registro?',
      'dxGantt-dialogDependencyDeleteConfirmation': 'prueba2',
      'dxGantt-dialogResourcesDeleteConfirmation': 'prueba3',
      'dxGantt-dialogStartTitle': 'Inicio',
      'dxGantt-dialogEndTitle': 'Fin',
      'dxGantt-dialogTaskDetailsTitle': 'Editar',
      'dxGantt-contextMenuDeleteTask': 'Eliminar actividad',
      'dxGantt-zoomIn': 'Ampliar',
      'dxGantt-zoomOut': 'Alejar',
      'dxGantt-deleteSelectedTask': 'Elimimar actividad',
    },
  })
  locale('es')
  const [tasks, setTasks] = useState([])
  const [popupVisible, setPopupVisible] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    Activity: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const formik = useFormik({
    validateOnChange: false,
    enableReinitialize: true,
    initialValues: {
      IdImplementationActivity: 0,
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      Activity: '',
      StartDate: '',
      EndDate: '',
    },
    validationSchema: GeneralDataSchema,
  })

  const getTasksList = async () => {
    try {
      const response = await getTechnicalAssistanceImplementationActivities(
        IdTechnicalAssistanceAnswer,
      )
      var item = []
      for (var i = 0; i < response.Data.length; i++) {
        item[i] = {
          id: response.Data[i].IdImplementationActivity,
          parentId: 0,
          title: response.Data[i].Activity,
          start: new Date(response.Data[i].StartDate),
          end: new Date(response.Data[i].EndDate),
        }
      }
      setTasks(item)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (IdTechnicalAssistanceAnswer !== undefined) {
      getTasksList()
    }
  }, [IdTechnicalAssistanceAnswer])

  const onHiding = async () => {
    setPopupVisible(false)
    formik.resetForm()
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const onTaskDblClick = (e) => {
    if (e.key !== 0) {
      // your code
      e.cancel = true
    }
  }

  return (
    <>
      <Gantt
        taskListWidth={500}
        scaleType="months"
        height={260}
        showResources={false}
        showDependencies={false}
        taskTitlePosition="none"
        onTaskDblClick={onTaskDblClick}
      >
        <ContextMenu enabled={false} />
        <Tasks dataSource={tasks} />

        <Toolbar>
          <Item name="zoomIn" />
          <Item name="zoomOut" />
        </Toolbar>

        <Column dataField="title" caption="Actividad" width={300} />
        <Column dataField="start" caption="Fecha inicio" />
        <Column dataField="end" caption="Fecha fin" />

        {/* <Validation autoUpdateParentTasks /> */}
        <Editing enabled allowResourceAdding={false}></Editing>
      </Gantt>

      <Popup
        title="Nueva actividad"
        showTitle={true}
        width={700}
        height={300}
        visible={popupVisible}
        hideOnOutsideClick
        onHiding={onHiding}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">Actividad</label>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  style={{ width: '100%' }}
                  variant="outlined"
                  onChange={(e) => {
                    formik.setFieldValue('Activity', e.target.value)
                  }}
                  value={formik.values.Activity}
                  autoComplete={false}
                />
                {formik.errors.Activity ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Activity}
                  </div>
                ) : null}
              </FormControl>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateStart"
                        label="Fecha Inicio"
                        type="date"
                        name="ImplementationDateStart"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          formik.setFieldValue('StartDate', e.target.value)
                        }}
                        value={formik.values.StartDate}
                        inputProps={{
                          min: Moment(StartExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(EndExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                      />
                    </Stack>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack component="form" noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateEnd"
                        name="ImplementationDateEnd"
                        label="Fecha fin"
                        type="date"
                        variant="outlined"
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) => {
                          formik.setFieldValue('EndDate', e.target.value)
                        }}
                        value={formik.values.EndDate}
                        inputProps={{
                          min: Moment(formik.values.StartDate)
                            .format('YYYY-MM-DD')
                            .toString(),
                          max: Moment(EndExecutionPeriod)
                            .format('YYYY-MM-DD')
                            .toString(),
                        }}
                      />
                    </Stack>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="buttonsPYME">
            <Button className="cancelButton" onClick={onHiding}>
              Cancelar
            </Button>

            <Button className="confirmButton" onClick={validateFormStatus}>
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Popup>
    </>
  )
}

export default React.memo(Table26)
